import { Container, Location } from "../components";

const LocationPage = () => {
    return (
        <Container>
            <Location />
        </Container>
    );
};

export default LocationPage;
